import * as S from './styles';
import { ClassSection } from './type';

interface ClassCardProps {
  item: ClassSection;
  onUpdate: (sectionId: number) => void;
  onDelete: (sectionId: number) => void;
}

const CardItem = ({
  label,
  value,
  withBorder = true,
}: {
  label: string;
  value: string;
  withBorder?: boolean;
}) => (
  <S.CardItem $withBorder={withBorder}>
    <span style={{ color: 'rgb(0,0,0,0.5)', flexShrink: 0 }}>{label}</span>
    <span>{value}</span>
  </S.CardItem>
);

const ClassCard = ({ item, onUpdate, onDelete }: ClassCardProps) => {
  const {
    class_section_semester,
    class_section_grade,
    class_section_name,
    class_section_subject,
    class_section_teacher_info,
    class_section_id,
    class_section_year,
  } = item;
  const formattedSemester = `${class_section_year}-${class_section_semester}`;
  const formattedClass = `${class_section_grade}-${class_section_name}`;
  console.log(class_section_id);
  return (
    <S.CardContainer>
      <S.Inner>
        <CardItem
          label="Он–Семестр"
          value={formattedSemester}
          withBorder={false}
        />
        <CardItem label="Хичээлийн нэр" value={class_section_subject} />
        <CardItem label="Курс–Бүлэг" value={formattedClass} />
        <CardItem label="Удирдах багш" value={class_section_teacher_info} />
      </S.Inner>
      <S.ButtonWrapper>
        <S.FuncButton
          onClick={() => onUpdate(class_section_id)}
          style={{ backgroundColor: '#6A3A87' }}
        >
          Засах
        </S.FuncButton>
        <S.FuncButton
          onClick={() => onDelete(class_section_id)}
          style={{
            backgroundColor: '#fff',
            color: '#6A3A87',
            border: '1px solid #6A3A87',
          }}
        >
          Устгах
        </S.FuncButton>
      </S.ButtonWrapper>
    </S.CardContainer>
  );
};

export default ClassCard;
